import { TEMPLATES_ROUTES } from '../../constants/_routes'
import templatesTypes from '../../constants/templatesTypes'
import { axios } from '../../services'

// import { try_force_logoff } from '../auth'

const create_template_request = () => {
  return {
    type: templatesTypes.create.request
  }
}

const create_template_success = (response) => {
  return {
    type: templatesTypes.create.success,
    payload: response.data.template
  }
}

const create_template_failure = (messages) => {
  return {
    type: templatesTypes.create.failure,
    payload: messages
  }
}

const create_template = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_template_request())

    // Request
    axios.post(
      TEMPLATES_ROUTES.create,
      values
    ).then( response => {
      // success
      dispatch( create_template_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating template."]
      }
      // dispatch( try_force_logoff(error.response) )
      window.showSnackbar('error', errors)
      dispatch( create_template_failure(errors))
    })
  }

}

export {
  create_template
}



// WEBPACK FOOTER //
// ./src/js/actions/templates/create.js